import Swiper from "swiper/swiper-bundle";

/***** -----------------------------
ページ読み込み時に処理
----------------------------- ******/
$(function () {
  headerMenu();
  accordion();
  smoothScroll();
  pageTop();
  moreShow();
  moreRead();
  tooltip();
  modal();
  inputDate();
  recommendSlider();
  checkedSlider();
});

//==========
//汎用function
//==========
// スクロール禁止
function htmlFix() {
  var st = $(window).scrollTop() * -1;
  $("html").addClass("is-fixed");
  $("body").css("top", st);
}

//スクロール禁止を解除
function htmlScroll() {
  var st = parseFloat($("body").css("top")) * -1;
  $("html").removeClass("is-fixed").scrollTop(st);
  $("body").removeAttr("style");
}

/***** -----------------------------
ヘッダーメニュー
----------------------------- ******/
function headerMenu() {
  const $trigger = $(".js-header-menu-trigger"),
    $panel = $(".js-header-menu-panel");

  //ナビを表示
  $trigger.on("click", function () {
    const $parents = $(this).parents(".js-header"),
      $overlay = $(".js-overlay-bg");

    if ($parents.hasClass("is-opened")) {
      $parents.removeClass("is-opened");
      $overlay.removeClass("is-active");
      $panel.slideUp();
    } else {
      $parents.addClass("is-opened");
      $overlay.addClass("is-active");
      $panel.slideDown();
    }

    // ページ内リンクをクリックでメニューを閉じる
    $(".js-smooth-scroll").on("click", function () {
      if ($parents.hasClass("is-opened")) {
        $parents.removeClass("is-opened");
        $panel.slideUp();
        $overlay.removeClass("is-active");
      }
    });

    // 背景をクリックでメニューを閉じる
    $overlay.on("click", function () {
      if ($parents.hasClass("is-opened")) {
        $parents.removeClass("is-opened");
        $panel.slideUp();
        $overlay.removeClass("is-active");
      }
    });
  });
}

/***** -----------------------------
アコーディオン
----------------------------- ******/
function accordion() {
  const $trigger = $(".js-accordion-trigger"),
    $target = $(".js-accordion-target");

  $trigger.click(function () {
    if ($(this).hasClass("is-opened")) {
      // アコーディオンを閉じる処理
      $(this).next($target).stop().slideUp();
      $(this).removeClass("is-opened");
    } else {
      // アコーディオンを開く処理
      $(this).next($target).stop().slideDown();
      $(this).addClass("is-opened");
    }
  });
}

/***** -----------------------------
スムーズスクロール
----------------------------- ******/
function smoothScroll() {
  $.easing.quart = function (x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  };

  //URLのハッシュ値を取得
  var urlHash = location.hash;
  //ハッシュ値があればページ内スクロール

  if (urlHash) {
    //スクロールを0に戻す
    $("html, body").stop().scrollTop(0);
    setTimeout(function () {
      //ロード時の処理を待ち、時間差でスクロール実行
      scrollToAnchor(urlHash);
    }, 2000);
  }

  scroll();
}

function scroll() {
  $(".js-smooth-scroll").on("click", function () {
    var speed = 400,
      href = $(this).attr("href"),
      target = $(href == "#" || href == "" ? "html" : href);
    scrollToAnchor(target);
    // return false; URLに追加必要
  });
}

function scrollToAnchor(hash) {
  var target = $(hash),
    header = $(".js-header").height(),
    position = target.offset().top,
    position = position < header ? position : position - header - 20; //固定ヘッダー分+α　を適宜追加する

  $("html, body").stop().animate(
    {
      scrollTop: position
    },
    1200,
    "quart"
  );
}

/***** -----------------------------
ページトップに戻る
----------------------------- ******/
function pageTop() {
  window.addEventListener("scroll", function () {
    const elm = document.querySelector(".js-pagetop");
    const scroll = window.scrollY;
    if (scroll > 100) {
      elm.style.opacity = "1";
      // console.log(scroll);
    } else if (scroll < 100) {
      elm.style.opacity = "0";
      // console.log(scroll);
    }
  });
}

/***** -----------------------------
もっと見る
----------------------------- ******/
function moreShow() {
  // 初期表示する件数
  const initialDisplayCount = 8;

  // ボタンのクラス名
  const buttonClassName = ".js-more-trigger";

  // ボタンの要素にクリックイベントを追加する関数
  function addClickEventToButtons(buttons) {
    buttons.each(function () {
      const button = $(this);
      const list = button.prevAll(".js-more-target");
      const items = list.find("li");

      // 初期表示する件数の要素以降を非表示にする関数
      function hideItems() {
        for (let j = initialDisplayCount; j < items.length; j++) {
          $(items[j]).hide();
          list.addClass("is-hidden");
        }
      }

      // ボタンがクリックされたときの処理
      function handleClick() {
        if (button.hasClass("is-opened")) {
          hideItems();
          button.removeClass("is-opened");
          list.addClass("is-hidden");
        } else {
          // 全ての要素を表示する
          items.show();
          button.addClass("is-opened");
          list.removeClass("is-hidden");
        }
      }

      // 初期表示する件数の要素以降を非表示にする
      hideItems();

      // ボタンにクリックイベントを追加
      button.on("click", handleClick);
    });
  }

  // ボタンの要素を取得
  const buttons = $(buttonClassName);

  // ボタンにクリックイベントを追加
  addClickEventToButtons(buttons);
}

/***** -----------------------------
続きを読む
----------------------------- ******/
// 初回表示時のcss指定の高さを配列で取得する
var initialOffsetHArray = [];

function moreRead() {
  // 要素の高さに合わせてボタンを表示
  function buttonVisibility() {
    $(".js-more-read-open").each(function (index) {
      var scrollH = this.scrollHeight; // スクロールを含む高さ
      var hiddenH = scrollH - initialOffsetHArray[index]; // css指定の高さ 配列で取得した値を順番に格納

      var $buttonBox = $(this).parent().find(".voice-card-pap__button-box"); // ボタンボックス
      var $button = $buttonBox.find(".js-more-read-trigger"); // ボタン単体

      if (hiddenH > 0) {
        if ($buttonBox.length === 0) {
          $(this)
            .parent()
            .append(
              '<div class="voice-card-pap__button-box"><button class="button-more-pap js-more-read-trigger">続きを読む</button></div>'
            );
        }
        if (!$button.hasClass("is-opened")) {
          $(this).removeClass("is-opened");
        }
      } else {
        $(this).addClass("is-opened");
        $buttonBox.remove();
      }
    });
  }

  // ボタン押下時の挙動
  function buttonToggleText() {
    var $open = $(this).closest(".js-more-read").children(".js-more-read-open");
    var $height = $open.get(0).scrollHeight; // 本来の高さ
    var $button = $(this);

    if ($open.hasClass("is-opened")) {
      //高さを戻す
      $open.css("height", "").removeClass("is-opened");
      //テキストを戻す
      $button.text("もっと見る").addClass("is-opened");
    } else {
      //続きを表示
      $open.addClass("is-opened");
      $open.css("height", $height);
      $button.text("閉じる").addClass("is-opened");
    }
  }

  // 画面リサイズに合わせてボタン表示有無切り替え
  $(window).on("resize", function () {
    buttonVisibility();
  });

  // ロード完了後初期表示用
  window.onload = function () {
    $(".js-more-read-open").each(function () {
      // 初期のcss指定の高さをセット
      initialOffsetHArray.push(this.offsetHeight);
    });
    buttonVisibility();
  };

  // 続きを読むクリックで実行
  $(".js-more-read").on("click", ".js-more-read-trigger", buttonToggleText);
}

//==========
//ツールチップ（hoverで開閉）
//==========
function tooltip() {
  //画面幅640以下の場合クリックで開閉
  if ($(window).width() < 640) {
    $(".js-tooltip")
      .off("mouseenter mouseleave")
      .click(function (event) {
        event.stopPropagation();
        var tooltipText = $(this).next(".js-tooltip-text");
        tooltipText.fadeIn();
        $(document).one("click", function (event) {
          if (!$(event.target).closest(".js-tooltip").length) {
            tooltipText.fadeOut();
          }
        });
      });
    //画面幅640以上でホバーで開閉
  } else {
    $(".js-tooltip")
      .off("mouseenter mouseleave")
      .hover(
        function () {
          $(this).next(".js-tooltip-text").fadeIn();
        },
        function () {
          $(this).next(".js-tooltip-text").fadeOut();
        }
      );
  }
}

$(window).on("load resize", function () {
  tooltip();
});

//==========
//モーダル
//==========
function modal() {
  const $modalTrigger = $(".js-modal-trigger"),
    $modalClose = $(".js-modal-close"),
    $modal = $(".js-modal-target"),
    $overlay = $(".js-overlay-bg");

  // モーダルを開く処理
  $modalTrigger.on("click", function (e) {
    e.preventDefault();

    const target = $($(this).attr("data-modal-target"));

    target.addClass("is-active");
    $overlay.addClass("is-active");
    htmlFix();
  });

  // モーダルを閉じる処理
  $modalClose.on("click", function () {
    $modal.removeClass("is-active");
    $overlay.removeClass("is-active");
    htmlScroll();
  });
}

//==========
//Flatpickr
//==========
function inputDate() {
  if ($(".js-input-date").length >= 1) {
    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent);
    }

    flatpickr(".js-input-date", {
      disableMobile: isMobileDevice(),
      locale: "ja"
    });
  }
}

//==========
//おすすめセミナー スライダー
//==========
function recommendSlider() {
  var swiper;

  const $recommendSlider = $(".js-recommend-slider"),
    $recommendSliderPage = $(".js-recommend-slider-pagination"),
    $recommendSliderPause = $(".js-recommend-slider-pause");

  if ($recommendSlider.length >= 1) {
    function initializeRecommendSwiper() {
      swiper = new Swiper($recommendSlider[0], {
        lazy: true,
        loop: true,
        speed: 300,
        centeredSlides: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        pagination: {
          el: $recommendSliderPage[0],
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 80
          }
        },
        keyboard: {
          enabled: true
        }
      });
    }

    // スライドが7枚未満のときは7枚まで複製
    function duplicateSlides() {
      const $recommendSliderWrapper = $(".js-recommend-slider-wrapper"),
        $recommendSliderSlides = $(".js-recommend-slider-slide");

      const requiredSlides = 7;
      let slideCount = $recommendSliderSlides.length;

      if (slideCount < requiredSlides) {
        const slidesToAdd = requiredSlides - slideCount;
        let slidesAdded = 0;

        while (slidesAdded < slidesToAdd) {
          $recommendSliderSlides.each(function () {
            if (slidesAdded >= slidesToAdd) return false; // Stop if we've added enough slides
            const $clone = $(this).clone();
            $recommendSliderWrapper.append($clone);
            slidesAdded++;
          });
        }
      }
    }

    $(document).ready(function () {
      duplicateSlides(); // スライドを複製
      initializeRecommendSwiper(); // ページが読み込まれたときにスライダーを初期化
    });

    $(window).resize(function () {
      swiper.update(); // 画面サイズが変更されたときにスライダーを更新
    });

    //再生/停止ボタン
    $recommendSliderPause.on("click", function () {
      if ($(this).hasClass("is-paused")) {
        swiper.autoplay.start();
        $(this).removeClass("is-paused");
      } else {
        swiper.autoplay.stop();
        $(this).addClass("is-paused");
      }
    });
  }
}

//==========
//最近チェックしたセミナー スライダー
//==========
function checkedSlider() {
  var swiper;

  const $checkedSlider = $(".js-checked-slider"),
    $checkedSliderNext = $(".js-checked-slider-next"),
    $checkedSliderPrev = $(".js-checked-slider-prev");

  if ($checkedSlider.length >= 1) {
    function initializeCheckedSwiper() {
      swiper = new Swiper($checkedSlider[0], {
        lazy: true,
        speed: 300,
        // slidesPerView: "auto",
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 10,
        navigation: {
          nextEl: $checkedSliderNext[0],
          prevEl: $checkedSliderPrev[0]
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        },
        // キーボード操作
        keyboard: {
          enabled: true
        }
      });
    }

    $(document).ready(function () {
      initializeCheckedSwiper(); // ページが読み込まれたときにスライダーを初期化
    });

    $(window).resize(function () {
      swiper.update(); // 画面サイズが変更されたときにスライダーを更新
    });
  }
}
